import React, { useRef } from 'react';
import { useModals } from '@sls-react/contexts/ModalsContext';
import { BaseModalProps } from '@sls-react/components/Modal/BaseModal';

type Props = {
  children: (onRequestClose: () => void) => React.ReactNode;
  trigger: (handleOpen: () => void) => React.ReactNode;
  modalProps?: Partial<BaseModalProps>;
};

const ManagedModal: React.FC<Props> = ({ children, modalProps, trigger }) => {
  const id = useRef(Date.now());
  const modals = useModals();

  return (
    <React.Fragment>
      {trigger(() =>
        modals.openModal(
          // @ts-ignore
          `managed-${id.current}`,
          {
            ...modalProps,
            onRequestClose: () => modals.closeModal(id.current),
          },
          children,
        ),
      )}
    </React.Fragment>
  );
};

export default ManagedModal;
